import React from "react";
import Lottie from "lottie-react";
import aboutContactUsAnimation from "../assests/aboutContactUs.json";
import { companyInfo } from "../data/companyData";
import "./About.css";

export default function Contact() {
  return (
    <div className="about-container">
      <div className="goalSection">
        <h1 className="goalTitle">Contact Us</h1>
        <p className="goalText">
          Reach out to discuss our AI SaaS products, partnerships, or enterprise licensing. We respond
          to all enquiries within 24 hours on business days.
        </p>
      </div>
      <div className="contactPage" id="contact-section">
        <div className="contactLeft">
          <h1>Get in Touch</h1>
          <p>
            Email us at {companyInfo.email} or call {companyInfo.phone}. Our team is based in
            Hyderabad, Telangana, India.
          </p>
          <div className="contactAnimation">
            <Lottie animationData={aboutContactUsAnimation} loop={true} />
          </div>
        </div>
        <div className="contactRight">
          <h2>Ready to Get Started?</h2>
          <p className="contactNote">
            Your email address will not be published. Required fields are marked *
          </p>
          <form className="contactForm" onSubmit={(e) => e.preventDefault()}>
            <input type="text" placeholder="Your Name*" aria-label="Your Name" />
            <input type="email" placeholder="Email*" aria-label="Email" />
            <textarea placeholder="Message..." aria-label="Message"></textarea>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
}
